/**
 * The torch — a spec with nothing in it but a LOD-0 model, and that is the point.
 *
 * It is placed only by the pathway-wall pass, which runs at LOD 0 alone, so `maxLod: 0` is not a
 * decision about what a distant torch should look like: there is no distant torch to draw. Its shape
 * comes from the shared TORCH_PARTS preset, rasterized once (buildingCommon), so a torch placed by
 * the build system and a torch grown by the terrain are the same object.
 *
 * It exists as a spec so that "every StampType has a spec" is TRUE rather than nearly true — the
 * registry's legacy switch is gone, and a new type cannot be added without saying what it is at every
 * level, including "nothing".
 */
import { StampType } from '../StampTypes.js';
import { TORCH_STAMP_VOXELS } from '../buildingCommon.js';
export const TORCH_SPEC = {
    type: StampType.TORCH,
    maxLod: 0,
    params: () => null,
    lod0: () => TORCH_STAMP_VOXELS,
};
//# sourceMappingURL=torch.js.map